export default __webpack_public_path__ + "locales/el-GR/BackupCodesDialog.json?hash=4278d2177a3271e8e1afd858631ed80d";